import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DashboardLayout from '../Layouts/DashboardLayout';
import FontStyleGrid from './components/FontStyleGrid';
import GenerateButton from './components/GenerateButton';
import { mockRootProps } from './FontStyleSelectionMockData';

import logger from '../../utils/logger';
const ContentContainer = styled(Box)(({ theme }) => ({
  maxWidth: '1200px',
  margin: '0 auto'
}));

const PageHeader = styled(Stack)(({ theme }) => ({
  gap: '16px',
  marginBottom: '40px'
}));

const PageTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '28px',
  fontWeight: 600,
  color: '#0B91D6'
}));

const PageDescription = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  color: '#30302E',
  lineHeight: '20px'
}));

const SelectionSection = styled(Stack)(({ theme }) => ({
  gap: '40px',
  alignItems: 'center'
}));

const SectionHeader = styled(Stack)(({ theme }) => ({
  gap: '6px',
  alignItems: 'center',
  textAlign: 'center'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '26px',
  fontWeight: 600,
  textTransform: 'capitalize',
  color: '#121927'
}));

const SectionDescription = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: '#30302E'
}));

const FontStyleSelection = ({ fontStyles: initialFontStyles }) => {
  const fontStyles = initialFontStyles || mockRootProps.fontStyles;
  const [selectedStyleId, setSelectedStyleId] = useState(
    fontStyles.find(style => style.selected)?.id || fontStyles[0]?.id
  );
  const [selectedReview, setSelectedReview] = useState(null);

  // Load selected review from localStorage
  React.useEffect(() => {
    const reviewData = localStorage.getItem('selectedReviewForPost');
    if (reviewData) {
      try {
        setSelectedReview(JSON.parse(reviewData));
      } catch (e) {
        logger.error('Error parsing selected review:', e);
      }
    }
  }, []);

  const handleStyleSelect = (styleId) => {
    setSelectedStyleId(styleId);
  };

  const handleGenerate = () => {
    const selectedStyle = fontStyles.find(style => style.id === selectedStyleId);
    logger.log('Generate clicked with style:', selectedStyle);
    logger.log('Selected review for post:', selectedReview);
    // Handle generate logic here - could navigate to post generation results
  };

  return (
    <DashboardLayout>
      <ContentContainer>
        <PageHeader>
          <PageTitle>Create Post</PageTitle>
          <PageDescription>
            {selectedReview 
              ? `Creating post from ${selectedReview.author}'s ${selectedReview.rating}-star review: "${selectedReview.text.substring(0, 100)}${selectedReview.text.length > 100 ? '...' : ''}"`
              : 'Choose a font style to customize your testimonial post design.'
            }
          </PageDescription>
        </PageHeader>

        <SelectionSection>
          <SectionHeader>
            <SectionTitle>Select Font Styles That You Like</SectionTitle>
            <SectionDescription>
              Choose a font style to customize the look and feel of your brand materials.
            </SectionDescription>
          </SectionHeader>

          <FontStyleGrid
            fontStyles={fontStyles}
            selectedStyleId={selectedStyleId}
            onStyleSelect={handleStyleSelect}
          />

          <GenerateButton
            onClick={handleGenerate}
            disabled={!selectedStyleId}
          />
        </SelectionSection>
      </ContentContainer>
    </DashboardLayout>
  );
};

export default FontStyleSelection;